<template>
  <v-dialog
    v-model="$store.state.loadingInfo.show"
    hide-overlay
    persistent
    width="300"
  >
    <v-card color="#424242" dark>
      <v-card-text>
        <v-progress-circular indeterminate color="white"></v-progress-circular>
        {{ $store.state.loadingInfo.text }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {};
</script>
